import styled from 'styled-components'

const StyledPaymentPlanSelect = styled.div`
  .radio label {
    display: flex;
    align-items: center;
  }
`

export default StyledPaymentPlanSelect
